import localStore from './localStore'
import { MyUtil } from './MyUtil'

// util工具类
class Util {
  //----------------------------------统一处理方法-----------------------------------
  //促销活动
  handlePromotions(dataList){
    let cartPromotionArr = MyUtil.getLocalCart().promotion
    return dataList.map(item => {
          item.isHave=true
          if(item.type === 5){//套餐
            //遍历各分组的所有商品
            item.promotionRuleVO.groupTotalPriceAmout=0
            item.isQuota=true //配额充足
            item.promotionRuleVO.rules=item.promotionRuleVO.rules.map((rItem,rIndex) => {
              rItem.index=rIndex
              rItem.name=rItem.setMealGroupTitle
              if(item.promotionRuleVO.setMealPriceType==1){//分组合计
                item.promotionRuleVO.groupTotalPriceAmout+=rItem.setMealGroupPrice
              }

              let allNum=0 
              rItem.haveEnable=true
              rItem.quotaEnable=true
              let allHave=0
              rItem.setMealProductList=rItem.setMealProductList.map(pItem=>{
                pItem.productNum=0
                pItem.isHave=pItem.isHave==1
                //配额
                pItem.quotaLimit=((pItem.quotaType===0 || pItem.quotaType===1 || pItem.quotaType===2) 
                                  && pItem.availableQty!==null 
                                  && `${pItem.availableQty}`.length>0)

                if(!pItem.setMealOrderRatio){
                  pItem.setMealOrderRatio=1
                }
                pItem.minNum=0
                let pMax=Number(pItem.setMealQuotaQty || 9999)       //商品限购
                let gMax=Number(rItem.setMealGroupQuotaQty || 9999)  //分组限购
                let qtyMax=pItem.quotaLimit?(pItem.availableQty*pItem.setMealOrderRatio):9999 //配额限购
                pItem.maxNum=Math.min(qtyMax,Math.min(pMax,gMax))

                pItem.isQuota=true //配额充足
                if(pItem.quotaLimit && pItem.maxNum<pItem.setMealOrderRatio){
                  pItem.isQuota=false  //设置了配合&配额不足
                }
                
                let isDefBuy=pItem.setMealIsDefaultOrder==1 //默认订购
                if(isDefBuy && !pItem.isQuota){
                  //必购品&设置了配合&配合小于最低订货比例；只判断必购品、不判断全组配额不足的情况
                  rItem.quotaEnable=false 
                }
                if(!pItem.isHave){//缺货
                  if(isDefBuy) rItem.haveEnable=false
                  allHave++
                }
                if(isDefBuy && pItem.isQuota && pItem.isHave){//默认购买
                  pItem.productNum=pItem.setMealOrderRatio
                  pItem.minNum=pItem.setMealOrderRatio //最小值
                  allNum+=pItem.productNum
                }
                return pItem
              })
              //if(item.id==6337) MyUtil.e("--rItem.quotaEnable-->>",rIndex,rItem.quotaEnable)
              if(rItem.haveEnable){
                rItem.haveEnable=!(allHave==rItem.setMealProductList.length)
              }

              if(!rItem.quotaEnable){
                item.isQuota=false
              }
              if(!rItem.haveEnable){
                item.isHave=false
              }
              return rItem
            });
            //if(item.id==6337) MyUtil.e("--rItem.quotaEnable-->>",item.quotaEnable)
            
          }else{
            item.promotionRuleVO.productList && item.promotionRuleVO.productList.forEach(pItem=>{
              //所有商品有货===活动有货
              if(pItem.isHave!=1){
                item.isHave=false
              }
            })
          }
          // 请求的列表与本地存储的购物车列表做比对，如果存在本地，产品列表加上购物车数量，如不存在，初始化为0
          if(cartPromotionArr && cartPromotionArr.length>0){
            let tmpArr=cartPromotionArr.filter(cItem=>{return cItem.id === item.id})
            if(tmpArr && tmpArr.length>0){
              let cItem = tmpArr[0]
              item.hover = false // 鼠标hover时效果
              let sum = 0
              if (item.type === 5) {//套餐:组合套餐特殊处理
                //item.shopCartNum = sum

              } else {
                let cartProductArr = cItem.promotionRuleVO ? (cItem.promotionRuleVO.productList || cItem.promotionRuleVO.products || []) : []
                cartProductArr.forEach((value, index) => {
                  if (value.isHave) {
                    sum += value.shopCartNum
                  }
                })
                item.shopCartNum = sum
                //MyUtil.e("购物车里已添加", item.title, sum)
                item.promotionRuleVO.productList && item.promotionRuleVO.productList.map(pItem => {
                  for (let j = 0; j < cartProductArr.length; j++) {
                    if (pItem.pCode === cartProductArr[j].pCode) {
                      pItem.shopCartNum = cartProductArr[j].shopCartNum
                    }
                  }
                  return pItem
                })
              }
              return item
            }
          }
          item.hover = false
          item.shopCartNum = 0
          return item
    })
  }

  //商品列表
  handleProducts(dataList){
    let cartProductArr = MyUtil.getLocalCart().product
    return dataList.map(item => {
          // 请求的列表与本地存储的购物车列表做比对，如果存在本地，产品列表加上购物车数量，如不存在，初始化为0
          if(cartProductArr && cartProductArr.length>0){
            for (let i = 0, len = cartProductArr.length; i < len; i++) {
              if (cartProductArr[i].pCode === item.pCode) {
                item.shopCartNum = cartProductArr[i].shopCartNum
                item.selected = cartProductArr[i].selected || false
                item.hover = false
                return item
              }
            }
          }
          item.hover = false
          item.selected = true
          item.shopCartNum = 0
          return item
    })
  }

  //=================================================================================


  
  deepClone (obj) {
    let result
    let oClass = this._isClass(obj)
    // 确定result的类型
    if (oClass === 'Object') {
      result = {}
    } else if (oClass === 'Array') {
      result = []
    } else {
      return obj
    }
    for (let key in obj) {
      let copy = obj[key]
      if (this._isClass(copy) === 'Object') {
        result[key] = this.deepClone(copy) // 递归调用
      } else if (this._isClass(copy) === 'Array') {
        result[key] = this.deepClone(copy)
      } else {
        result[key] = obj[key]
      }
    }
    return result
  }
  _isClass (o) {
    if (o === null) return 'Null'
    if (o === undefined) return 'Undefined'
    return Object.prototype.toString.call(o).slice(8, -1)
  }
  formatThousand (value) {
    var b = false
    if (!value) {
      return '0.00'
    }
    value = value.toString()
    if (value.indexOf('-') !== -1) {
      b = true
      value = value.substring(1, value.length)
    }
    if (/^-?[0-9]+(.[0-9]+)?$/.test(value)) {
      value = value.toString().replace(/^(\d*)$/, '$1.')
      value = (value + '00').replace(/(\d*\.\d\d)\d*/, '$1')
      value = value.replace('.', ',')
      var re = /(\d)(\d{3},)/
      while (re.test(value)) {
        value = value.replace(re, '$1,$2')
      }
      value = value.replace(/,(\d\d)$/, '.$1')
    }
    if (b) {
      value = '-' + value
    }
    return value
  }

}

function plugin (Vue) {
  let ut = new Util()
  if (plugin.installed) {
    return
  }
  Object.defineProperties(Vue.prototype, {
    $util: {
      get () {
        return ut
      }
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

if (!String.prototype.trim) {
  // 清除字符串两端空格，包含换行符、制表符
  String.prototype.trim = function () {
    return this.replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, '')
  }
}

Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export default plugin



// WEBPACK FOOTER //
// ./src/util/index.js